import * as CryptoJS from 'crypto-js';
import { environment } from "src/environments/environment";

export const encrypt = (data: string): string => {
    return CryptoJS.AES.encrypt(data, environment.claveBase).toString();
};

export const decrypt = (valueEncrypt: string): string | null => {
    let valueDecrypt = CryptoJS.AES.decrypt(valueEncrypt, environment.claveBase).toString(CryptoJS.enc.Utf8);
    if (!valueDecrypt) {
        return null;
    }
    return valueDecrypt;
};
